import {
  collection,
  doc,
  type Firestore,
  type FirestoreDataConverter,
  type QueryDocumentSnapshot,
} from 'firebase/firestore'
import { modelItemStream } from '../../firestore-mobx/stream'
import type { FirebaseRepository } from '../../models/FirebaseRepository'
import { buildUnsupportedConverter } from '../shared/noops'
import type { FirestoreSettingsDeadAirDetector } from './schema'
import { schema } from './schema'
import { SettingsDeadAirDetector } from '../../models/SettingsDeadAirDetector'

const unsupported =
  buildUnsupportedConverter<FirestoreSettingsDeadAirDetector>()

const converter: FirestoreDataConverter<FirestoreSettingsDeadAirDetector> = {
  toFirestore: unsupported.toFirestore,
  fromFirestore: (snapshot: QueryDocumentSnapshot) => {
    return schema.parse(snapshot.data())
  },
}

export const getDocRef = (firestore: Firestore) => {
  return doc(
    collection(firestore, 'settings'),
    'dead_air_detector'
  ).withConverter(converter)
}

export const getSettingsDeadAirDetector = (repository: FirebaseRepository) => {
  const docRef = getDocRef(repository.firestore)

  return modelItemStream(repository, docRef, SettingsDeadAirDetector)
}
